import { doc, getDoc } from 'firebase/firestore';
import { db } from '../config';

export async function getUserData(userId: string) {
  try {
    const userDoc = await getDoc(doc(db, 'users', userId));
    if (!userDoc.exists()) {
      throw new Error('User data not found');
    }
    return userDoc.data();
  } catch (error: any) {
    console.error('Error fetching user data:', error);
    throw new Error(error.message || 'Failed to fetch user data');
  }
}